'use client';

import { useParams } from 'next/navigation';

import ar from '@/core/dictionaries/ar.json';
import en from '@/core/dictionaries/en.json';
import fa from '@/core/dictionaries/fa.json';
import { Dictionary, Locale } from '@/core/lib/dict';

const dictionaries: Record<Locale, Dictionary> = {
  en,
  fa,
  ar,
};

export function useDictionary() {
  const params = useParams();
  const lang = (params?.lang as Locale) || 'fa';
  const dictionary = dictionaries[lang] || dictionaries.fa;
  return { dictionary, lang };
}